module.exports = new __parcel__URL__("cornershop-new-web.11b52b92.png").toString();